import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api/posts/`;

// Create Product
const createPost = async (formData) => {
  const response = await axios.post(API_URL, formData);
  return response.data;
};

// Get Products
const getPosts = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};
// togglePublish
const togglePublish = async (postId) => {
  const response = await axios.patch(`${API_URL}/${postId}/publish`);
  return response.data;
};

// Get getICYMIPosts
const getICYMIPosts = async () => {
  const response = await axios.get(API_URL + `icymi`);
  return response.data;
};

// Get relatedPosts
const getRelatedPosts = async (slug) => {
  const response = await axios.get(API_URL + `related/${slug}`);
  return response.data;
};
// Get relatedPosts
const getUpNextPosts = async (slug) => {
  const response = await axios.get(API_URL + `up-next/${slug}`);
  return response.data;
};

// Delete Post
const deletePost = async (id) => {
  const response = await axios.delete(API_URL + id);
  return response.data;
};

// Get Post
const getPost = async (identifier) => {
  const response = await axios.get(API_URL + identifier);
  return response.data;
};

// Get mostReadPost
const getMostReadPosts = async () => {
  const response = await axios.get(API_URL + `most-read`);
  return response.data;
};

// Get mostReadPost
const getTrendyPosts = async () => {
  const response = await axios.get(API_URL + `trendy`);
  return response.data;
};

// Get mostReadPost
const getHotNews = async () => {
  const response = await axios.get(API_URL + `hot`);
  return response.data;
};

// Update Product
const updatePost = async (id, formData) => {
  const response = await axios.patch(API_URL + id, formData);
  return response.data;
};

// Update Product
const addComment = async (id, formData) => {
  const response = await axios.post(API_URL + `${id}/comments`, formData);
  return response.data;
};

// addLike
const addLike = async (id, formData) => {
  const response = await axios.put(API_URL + `addLike/${id}`);
  return response.data;
};

// Update Product
const removeLike = async (id, formData) => {
  const response = await axios.put(API_URL + `removeLike/${id}`);
  return response.data;
};

// Review Product
const reviewPost = async (id, formData) => {
  const response = await axios.patch(API_URL + `review/${id}`, formData);
  return response.data.message;
};

// Delete Review
const deleteReview = async (id, formData) => {
  const response = await axios.patch(API_URL + `deleteReview/${id}`, formData);
  return response.data.message;
};

// Update Review
const updateReview = async (id, formData) => {
  const response = await axios.patch(API_URL + `updateReview/${id}`, formData);
  return response.data.message;
};

const postService = {
  createPost,
  getPosts,
  togglePublish,
  getICYMIPosts,
  getRelatedPosts,
  getUpNextPosts,
  deletePost,
  getPost,
  getMostReadPosts,
  getTrendyPosts,
  getHotNews,
  updatePost,
  addComment,
  addLike,
  removeLike,
  reviewPost,
  deleteReview,
  updateReview,
  // getNewsApi,
};

export default postService;
